export function initDir() {
  const STORAGE_KEY = 'dcco-dir';
  const toggles = document.querySelectorAll('[data-dir-toggle]');

  function applyDir(dir) {
    document.documentElement.setAttribute('dir', dir);
    document.documentElement.setAttribute('lang', dir === 'rtl' ? 'ar' : 'en');
    localStorage.setItem(STORAGE_KEY, dir);
    updateIcons(dir);
  }

  function updateIcons(dir) {
    toggles.forEach(btn => {
      const icon = btn.querySelector('i');
      if (!icon) return;
      icon.className = dir === 'rtl' ? 'fa-light fa-arrow-right-arrow-left' : 'fa-light fa-arrow-right-arrow-left';
    });
  }

  toggles.forEach(btn => {
    btn.addEventListener('click', () => {
      const current = document.documentElement.getAttribute('dir') || 'rtl';
      applyDir(current === 'rtl' ? 'ltr' : 'rtl');
    });
  });

  const stored = localStorage.getItem(STORAGE_KEY) || 'rtl';
  updateIcons(stored);
}
